import L from "leaflet";

export class Renderer {
    constructor() {
        this._description = undefined;
        this._leaflet_map = undefined;
        this._geojson_layer = undefined;
        this._cluster_group = undefined;
    }

    _clear_features() {
        this._geojson_layer.remove();

        if (this._cluster_group) {
            this._cluster_group.remove();
        }
    }

    _load_features() {
        this._geojson_layer = L.geoJSON(undefined, {
            onEachFeature: (feature, layer) => {
                const popup = this.popupFromFeature(feature);

                if (popup) {
                    layer.bindPopup(popup);
                }

                layer.on('click', event => this.onFeatureClick(event.target.feature));
            },
        });

        for (const feature of this._description.props.geojson_features) {
            const style = this.styleFromFeature(feature);

            if (style) {
                this._geojson_layer.addData(feature).setStyle(style);
            } else {
                this._geojson_layer.addData(feature);
            }
        }

        if (this._description.props.clustering_enabled) {
            this._cluster_group = L.markerClusterGroup();

            this._leaflet_map.addLayer(this._cluster_group);

            this._cluster_group.addLayer(this._geojson_layer);
        } else {
            this._leaflet_map.addLayer(this._geojson_layer);
        }

        if (this._description.props.fit_features) {
            this._leaflet_map.fitBounds(this._geojson_layer.getBounds(), { padding: [40, 40] });
        }
    }

    mount(description) {
        this._description = description;

        if (this._leaflet_map !== undefined) {
            console.error("map was already mounted");

            return;
        }

        if (description.node.nodeName !== "DIV") {
            console.error("Leaflet will only mount on <div> elements");

            return;
        }

        this._leaflet_map = L.map(
            this._description.node,
            {
                minZoom: this._description.props.min_zoom,
                maxZoom: this._description.props.max_zoom,
            }
        ).setView(
            [
                this._description.props.initial_center[1],
                this._description.props.initial_center[0]
            ],
            this._description.props.initial_zoom
        ).on('click', event => this.onMapClick({ latitude: event.latlng.lat, longitude: event.latlng.lng }));

        L.tileLayer(
            this._description.props.tile_url_template,
            {
                attribution: this._description.props.attribution,
            }
        ).addTo(this._leaflet_map);

        this._load_features();

        return;
    }

    refresh(description) {
        this._description = description;

        this._clear_features();
        this._load_features();
    }

    static popupFromFeature(feature) {
        return feature.properties && feature.properties.popup;
    }

    popupFromFeature(feature) {
        return this.constructor.popupFromFeature(feature);
    }

    static styleFromFeature(feature) {
        return feature.properties && feature.properties.style;
    }

    styleFromFeature(feature) {
        return this.constructor.styleFromFeature(feature);
    }

    static onFeatureClick(feature) {
        // noop by default
    }

    onFeatureClick(feature) {
        this.constructor.onFeatureClick(feature);
    }

    static onMapClick(details) {
        // noop by default
    }

    onMapClick(details) {
        this.constructor.onMapClick(feature);
    }
}
